import React, { Component } from "react";
import { Routes, Navigate, Route } from "react-router";

import { ApiManagement, SideNav } from "./";
import { AdminRoute } from "./../../";
import PageWithSidebar from "components/PageWithSidebar";

import RegisteredAccounts from "./Accounts/RegisteredAccounts";
import AdminAccounts from "./Accounts/AdminAccounts";
import OnlyRestAPIAccounts from "./Accounts/OnlyRestAPIAccounts";
import OnlyWebsocketAccounts from "./Accounts/OnlyWebsocketAccounts";
import IkanoUserGroupAccounts from "./Accounts/IkanoUserGroupAccounts";
import NonIkanoUserGroupAccounts from "./Accounts/NonIkanoUserGroupAccounts";
import DeveloperToolsAccounts from "./Accounts/DeveloperToolsAccounts";
import PendingRequests from "./Accounts/PendingRequests";

function RedirectToApiManagement() {
  return <Navigate to="/admin/apis" />;
}

export class Admin extends Component {
  render() {
    return (
      <PageWithSidebar sidebarContent={<SideNav />}>
        <>
          <Routes>
            <Route
              end
              from="/admin"
              element={
                <AdminRoute>
                  <RedirectToApiManagement />
                </AdminRoute>
              }
            />
            <Route
              end
              path="/apis"
              element={
                <AdminRoute>
                  <ApiManagement />
                </AdminRoute>
              }
            />
            <Route
              end
              path="/accounts"
              element={
                <AdminRoute>
                  <RegisteredAccounts />
                </AdminRoute>
              }
            />
            <Route
              end
              path="/accounts/admins"
              element={
                <AdminRoute>
                  <AdminAccounts />
                </AdminRoute>
              }
            />
            <Route
              end
              path="/accounts/rest-apis-users"
              element={
                <AdminRoute>
                  <OnlyRestAPIAccounts />
                </AdminRoute>
              }
            />
            <Route
              end
              path="/accounts/websocket-apis-users"
              element={
                <AdminRoute>
                  <OnlyWebsocketAccounts />
                </AdminRoute>
              }
            />
            <Route
              end
              path="/accounts/ikano-users"
              element={
                <AdminRoute>
                  <IkanoUserGroupAccounts />
                </AdminRoute>
              }
            />
            <Route
              end
              path="/accounts/non-ikano-users"
              element={
                <AdminRoute>
                  <NonIkanoUserGroupAccounts />
                </AdminRoute>
              }
            />
            <Route
              end
              path="/accounts/developer-tools-users"
              element={
                <AdminRoute>
                  <DeveloperToolsAccounts />
                </AdminRoute>
              }
            />
            <Route
              end
              path="/accounts/requests"
              element={
                <AdminRoute>
                  <PendingRequests />
                </AdminRoute>
              }
            />
          </Routes>
          {/* <AdminRoute exact path='/admin/accounts/invites' component={PendingInvites} /> */}
        </>
      </PageWithSidebar>
    );
  }
}
